const Intro = () => {
  return (
    <section
      className='pt-20 lg:pb-20 bg-black text-white'
      id='about'
    >
      <div className='container max-w-6xl mx-auto'>
        <div className='flex flex-col lg:flex-row items-center justify-between gap-12'>
          <div className='flex-1 lg:text-left px-4 mx-auto'>
            <h2 className='text-3xl md:text-4xl font-bold text-white mb-6'>
              <span className='text-accent'>TheChamps</span> is your all-in-one
              fitness challenge and tracker app
            </h2>
            <p className='text-lg md:text-xl text-gray-300 mb-8'>
              TheChamps built to help you stay consistent, track progress, and
              transform your body
            </p>
            <button
              className='bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105'
              // onClick={() => window.open('https://thechamps.app', '_blank')}
              onClick={() => (window.location.href = 'https://thechamps.app')}
            >
              Start Your First 9DAYS
            </button>
          </div>
          <div className='flex-1 flex justify-center lg:px-4'>
            <div className='relative'>
              <video
                src='https://static-resource.thechamps.app/vod/thechamps-app.mp4'
                autoPlay
                muted
                loop
                playsInline
                className='w-full h-full object-cover'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
